export const FETCH_DASHBOARD_STATUS = 'FETCH_DASHBOARD_FETCH_STATUS';

export const FETCH_DASHBOARD_STATUS_IS_PENDING = 'FETCH_DASHBOARD_FETCH_STATUS_IS_PENDING';

export const FETCH_DASHBOARD_STATUS_IS_ERROR = 'FETCH_DASHBOARD_FETCH_STATUS_IS_ERROR';
